import React, { useEffect } from 'react'

import { Provider, useDispatch, useSelector } from 'react-redux'
import store, { persistor } from '../../../js/lib/redux/store.js'
import { PersistGate } from 'redux-persist/integration/react'
import Inpath from './Inpath.js'
import BookingChoices from '../Booking/components/BookingChoices.js'
import BookingStep1 from '../Booking/BookingStep1.js'
import constants from '../../../js/lib/constants.js'
import { setStep, setType } from '../../../js/lib/redux/slices/booking.js'

const InpathIndex = () => {
  const { dictionary, pickUpDetails, dropOffDetails } = window.inpathData
  const { step } = useSelector((state) => state.booking)
  const bookingStep = constants.booking.pageNumber.vehicles

  const dispatch = useDispatch()

  const handleBackToResults = () => {
    dispatch(setStep(bookingStep))
  }

  useEffect(() => {
    dispatch(setType('inpath'))
  }, [])

  //reset the store here
  return (
    <>
      {step !== bookingStep && (
        <div className="s-back-to-results">
          <div className="page-container">
            <div className="s-back-to-results__btn">
              <button
                type="button"
                className="btn p-0"
                onClick={handleBackToResults}>
                <i className="icon-chevron-left"></i>
                <span className="px-2">{dictionary.backToResults}</span>
              </button>
            </div>
          </div>
        </div>
      )}
      <BookingChoices
        dictionary={dictionary}
        pickUpDetails={pickUpDetails}
        dropOffDetails={dropOffDetails}
        inpath
      />
      {step === bookingStep ? <BookingStep1 inpath /> : <Inpath />}
    </>
  )
}

export default () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <InpathIndex />
    </PersistGate>
  </Provider>
)
